import { render } from "./FilerobotImageEditor.vue?vue&type=template&id=6381426b"
import script from "./FilerobotImageEditor.vue?vue&type=script&lang=js"
export * from "./FilerobotImageEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__